import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Modal from '../components/Shared/Modal.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/home',
        name: 'Home',
        component: Home
    },
    {
        path: '/about',
        name: 'About',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
        path: '/careers',
        name: 'Careers',
        component: () =>
            import ( /* webpackChunkName: "careers" */ '../views/careers/index.vue')
    },
    {
        path: '/careers/:job',
        name: 'view-job',
        component: () =>
            import ( /* webpackChunkName: "careers" */ '../views/careers/job.vue')
    },
    {
        path: '/modal',
        name: 'Modal',
        component: Modal
    },
    {
        path: '*',
        redirect: '/home'
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router